import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyAGcVUwu56ExZdAd6PIeTjQPqN0CrnPcs8",
  authDomain: "detre-e7230.firebaseapp.com",
  projectId: "detre-e7230",
  storageBucket: "detre-e7230.firebasestorage.app",
  messagingSenderId: "527213361650",
  appId: "1:527213361650:web:cae7a3474d505ec504136b",
  measurementId: "G-3FVPWMRRWL"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
